import { ClassNameFormatter } from "@bem-react/classname";
import { FormComponentProps } from "../types";

/** Typ funkce `generateFormComponentClasses` */
type GenerateFormComponentClassesType = {
    (classNames: ClassNameFormatter,
     props: NonNullable<Pick<FormComponentProps,
         | "disabled"
         | "encrypted"
         | "invalid"
         | "required"
         | "backgroundColor"
         | "readOnly"
         >>,
     extraClasses?: string[]
    ): string;
};

/**
 * Funkce vytvoří názvy CSS tříd pro obecné formulářové komponenty dle zadaných props.
 * Dodatečné názvy tříd se přidají k vygenerovaným názvem. Názvy jsou odděleny mezerou.
 *
 * @param classNames Funkce pro tvorbu tříd se zadefinovaným namespacem.
 * např. <code>bemClassNames("react-component");</code>
 * @param props Props podle kterých se generují třídy.
 * @param props.disabled - Příznak, zda se má pole zobrazit jako zakázané.
 * @param props.encrypted - Příznak, zda se má pole zobrazit jako šifrované.
 * @param props.invalid - Příznak, zda se má pole zobrazit jako nevalidní.
 * @param props.required - Příznak, zda se má pole zobrazit jako povinné.
 * @param props.backgroundColor - Barva pozadí pole.
 * @param extraClasses - Názvy dodatečných CSS tříd.
 */
export const generateFormComponentClasses: GenerateFormComponentClassesType = (
    classNames: ClassNameFormatter,
    {
        disabled,
        encrypted,
        invalid,
        required,
        backgroundColor,
        readOnly,
    },
    extraClasses,
) => {
    const classes = extraClasses ? [...extraClasses] : [];
    if (disabled) {
        classes.push(classNames("disabled"));
    } else if (encrypted) {
        classes.push(classNames("encrypted"));
    } else if (invalid) {
        classes.push(classNames("invalid"));
    } else if (readOnly) {
        classes.push(classNames("read-only"));
    } else {
        classes.push(classNames("enabled", {
            required,
            background: backgroundColor,
        }));
    }
    return classes.join(" ");
};
